import { DataTable, TableFooter } from 'bold-ui'
import { CpfOrCns } from 'components/CpfOrCns'
import { TableBox } from 'components/table'
import { usePagination } from 'components/table/usePagination'
import { css } from 'emotion'
import type { Cidadao } from 'graphql/types.generated'
import React from 'react'
import { formatNomeCidadao } from 'view/cidadao/util-cidadao'

import { CidadaoStatusGrupos } from './CidadaoStatusGrupos'
import { IdadeCidadaoGrupos } from './IdadeCidadaoGrupos'

type CidadaoRow = Pick<
  Cidadao,
  'id' | 'nome' | 'nomeSocial' | 'cpf' | 'cns' | 'dataNascimento' | 'sexo' | 'faleceu' | 'unificado'
>

interface CidadaoTableProps {
  items: CidadaoRow[]
}

export const CidadaoTable = (props: CidadaoTableProps) => {
  const { items } = props
  const { paginatedItems, tableProps } = usePagination({ items, initialPageSize: 5 })

  return (
    <TableBox>
      <DataTable<CidadaoRow>
        rows={paginatedItems}
        columns={[
          {
            name: 'nome',
            header: 'Nome',
            render: (row) => formatNomeCidadao({ nome: row.nome, nomeSocial: row.nomeSocial }),
            style: styles.tableRowNome,
          },
          {
            name: 'cpfCns',
            header: 'CPF ou CNS',
            render: (row) => <CpfOrCns cpf={row.cpf} cns={row.cns} />,
            style: styles.tableRowCpfCns,
          },
          {
            name: 'dataNascimento',
            header: 'Data de nasc.',
            render: (row) => <IdadeCidadaoGrupos dataNascimento={row.dataNascimento} />,
            style: styles.tableRowCommon,
          },
          {
            name: 'sexo',
            header: 'Sexo',
            render: (row) => row.sexo?.titleCase() ?? '-',
            style: styles.tableRowCommon,
          },
          {
            name: 'status',
            header: '',
            render: (row) => <CidadaoStatusGrupos faleceu={row.faleceu} unificado={row.unificado} />,
            style: styles.tableRowStatus,
          },
        ]}
      />
      <TableFooter style={styles.tableFooter} {...tableProps} />
    </TableBox>
  )
}

const styles = {
  tableFooter: css`
    border-top: 0;
  `,
  tableRowNome: css`
    width: 15rem;
    line-height: 1.5rem;
  `,
  tableRowCpfCns: css`
    width: 14rem;
    line-height: 1.5rem;
  `,
  tableRowCommon: css`
    width: 8rem;
    line-height: 1.5rem;
  `,
  tableRowStatus: css`
    width: 12rem;
    line-height: 1.5rem;
  `,
}
